import { CircularProgress } from '@mui/material'
import { useLoadingStore } from 'stores/loading.store'

export default function CircularIndeterminate() {
  const isGlobalLoading = useLoadingStore((state) => state.isGlobalLoading)

  return isGlobalLoading ? (
    <div className="fixed top-0 left-0 z-[1201] bg-slate-100 bg-opacity-50">
      <div className="flex items-center justify-center top-0 left-0 w-[100vw] h-[100vh] z-50">
        <CircularProgress />
      </div>
    </div>
  ) : (
    <></>
  )
}
